import React from 'react';
import './NotesPanel.css';

export const NotesPanel = ({ isOpened, teamName, notes, toggleClass }) => {
    return (
        <div className={isOpened ? 'notes-panel is-open' : 'notes-panel is-closed'}>
            <div className="notes-panel-header">
                <div className="notes-panel-title">{teamName}</div>
                <button className="notes-panel-close-button" onClick={toggleClass}>&times;</button>
            </div>
            <div className="notes-panel-body">
                {notes && notes.length > 0 ? (
                    notes.map((n, index) => (
                        <div key={index} className="judge-note-block">
                            <div className="note-author">
                                <strong style={{textTransform:'capitalize'}}>- {n.judgeName.split('@')[0]}</strong>
                            </div>
                            <div>{n.text}</div>
                        </div>
                    ))
                ) : (
                    <div className="no-notes-message">No notes available for this team.</div>
                )}
            </div>
        </div>
    );
};

export default NotesPanel;